import {
  CHECK_CONCURRENT_STREAM_REQUEST,
  CHECK_CONCURRENT_STREAM_SUCCESS,
  CHECK_CONCURRENT_STREAM_FAILURE,
  CLEAR_CONCURRENT_STREAM,
} from '../../actions/concurrentStreamActions'

const initialState = {
  sessionId: null,
  playbackUrl: null,
  channel: null,
  showModal: false,
  loading: false,
  error: null,
}

const ConcurrentStreamReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_CONCURRENT_STREAM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case CHECK_CONCURRENT_STREAM_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload,
        error: null,
      }
    case CHECK_CONCURRENT_STREAM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case CLEAR_CONCURRENT_STREAM:
      return {
        ...initialState,
        loading: action.payload.loading,
        ...action.payload,
      }
    default:
      return state
  }
}

export default ConcurrentStreamReducer
